/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_account_balance_big_circle from "../../assets/images/pictures/icon/ic_account_balance_big_circle-64px.svg";
import ic_person_pin_circle from "../../assets/images/pictures/icon/person_pin_circle-40px.svg";
import ic_open_brower_circle from "../../assets/images/pictures/icon/ic_open_in_browser_circle-40px.svg";
import ic_euro_circle from "../../assets/images/pictures/icon/ic_euro_symbol_circle-40px.svg";
import ic_car_direction_circle from "../../assets/images/pictures/icon/ic_directions_car_circle-40px.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import NavbarBottom from "../../components/global/NavbarBottom";
import acb from "../../assets/images/logos/banking/ACB.png";
import eximbank from "../../assets/images/logos/banking/eximbank.png";
import pgbank from "../../assets/images/logos/banking/pgbank.png";
import ocb from "../../assets/images/logos/banking/ocb.png";
import techcom from "../../assets/images/logos/banking/techcombank.png";
import cover from "../../assets/images/logos/case/cover-financial.png";

const CaseStudiesFinancialContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="industries mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_account_balance_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-1.heading"
                )}
              </h2>
              <p className="">
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-sm-10 col-sm-offset-1 mb-60">
              <ul className="list-inline text-center">
                <li>
                  <img
                    className="img-bw client-cases"
                    src={acb}
                    alt="ACB Bank"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={eximbank}
                    alt="Exim Bank"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={pgbank}
                    alt="PG Bank"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={ocb}
                    alt="OCB Bank"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={techcom}
                    alt="Techcom Bank"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-color p-0 mt-50">
        <div className="container">
          <div className="row stages">
            <div className="col-xs-12 text-center">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-2.big-heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 text-center mb-10">
              <p>
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-2.big-description"
                )}
              </p>
            </div>
          </div>
          <div className="row mb-30">
            <div className="col-sm-6 stages-legal__box pl-md-0">
              <img src={ic_person_pin_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-description-1"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-6 stages-legal__box pr-md-0">
              <img src={ic_open_brower_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-description-2"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-80">
            <div className="col-sm-6 stages-legal__box pl-md-0">
              <img src={ic_euro_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-heading-3"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-description-3"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-6 stages-legal__box pr-md-0">
              <img src={ic_car_direction_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-heading-4"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-financial-page.case-studies-financial-page-content.content-2.small-description-4"
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="industries">
        <div className="container">
          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img
                className="img-responsive"
                src={cover}
                alt="Thumbnail pages of Financial Teams and GoPaperless: A White Paper"
              />
            </div>
            <div className="col-sm-7">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-3.description-2"
                )}
              </p>
              <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-financial-page.case-studies-financial-page-content.content-3.button-access"
                )}
              </a>
            </div>
          </div>
        </div>

        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesFinancialContent;
